import React, { useState } from "react";
import { CSSTransition } from "react-transition-group";
import { withTranslation } from "react-i18next";
import Accordion from "@clarion/foundation/dist/Helpers/components/Accordion/index";
import Critical from "../Icons/Critical/index";
import Severe from "../Icons/Severe/index";
import Info from "../Icons/Info/index";
import CloseIcon from "@clarion/foundation/dist/Theming/icons/CloseIcon/index";
import RichTextPanel from "@clarion/foundation/dist/Helpers/components/RichTextPanel/index";
import "./index.css";
const Icon = ({
  type
}) => {
  switch (type) {
    case "critical":
      {
        return /*#__PURE__*/React.createElement(Critical, {
          className: "notification__icon"
        });
      }
    case "severe":
      {
        return /*#__PURE__*/React.createElement(Severe, {
          className: "notification__icon"
        });
      }
    default:
      {
        return /*#__PURE__*/React.createElement(Info, {
          className: "notification__icon"
        });
      }
  }
};
const Notification = ({
  type,
  data,
  notificationsAmount,
  setNotificationsAmnount,
  t
}) => {
  const [showNotification, setShowNotification] = useState(true);
  const isCritical = data.Severity === "Critical";
  const closeLabel = t("Close");
  const close = () => {
    const dismissedNotifications = JSON.parse(window.localStorage.getItem("dismissedNotifications")) || [];
    setShowNotification(false);
    setNotificationsAmnount(notificationsAmount - 1);
    dismissedNotifications.push(data.Id);
    window.localStorage.setItem("dismissedNotifications", JSON.stringify(dismissedNotifications));
  };
  return /*#__PURE__*/React.createElement(CSSTransition, {
    in: showNotification,
    classNames: "notifications-fade",
    timeout: 300,
    appear: true,
    unmountOnExit: true
  }, /*#__PURE__*/React.createElement("div", {
    className: `notification ${isCritical ? "notification--critical" : ""} wrapper wrapper--narrow`
  }, data.Description ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Accordion, {
    isAlert: true,
    initCollapsed: !isCritical,
    title: data.Heading,
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: type
    })
  }, /*#__PURE__*/React.createElement("time", {
    className: "notification__date",
    dateTime: data.PublishedDate
  }, data.PublishedDateFormatted), /*#__PURE__*/React.createElement(RichTextPanel, {
    className: "notification__rich-text copy-small",
    text: {
      value: data.Description
    }
  })), /*#__PURE__*/React.createElement("button", {
    className: "icon-btn icon-btn--small icon-btn--secondary",
    onClick: close,
    "aria-label": closeLabel
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-btn__inner"
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    className: "icon-btn__svg"
  }), /*#__PURE__*/React.createElement("span", {
    className: "visually-hidden"
  }, closeLabel)))) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    role: "alert",
    className: "notification__inner"
  }, /*#__PURE__*/React.createElement(Icon, {
    type: type
  }), /*#__PURE__*/React.createElement("span", {
    className: "notification__title"
  }, data.Heading)), /*#__PURE__*/React.createElement("button", {
    className: "icon-btn icon-btn--small icon-btn--secondary",
    onClick: close,
    "aria-label": closeLabel
  }, /*#__PURE__*/React.createElement("span", {
    className: "icon-btn__inner"
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    className: "icon-btn__svg"
  }), /*#__PURE__*/React.createElement("span", {
    className: "visually-hidden"
  }, closeLabel))))));
};
export default withTranslation()(Notification);